import { RouteParam } from ".";
import LandingScreen from "../ui/pages/landing_screen";
import Maintainence from "../ui/pages/maintainence";

const landing_page_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: true,
    exact: true,
    path: "/",
    component: LandingScreen,
    // component: Maintainence,
  },
];

export default landing_page_routes;
